// material-ui
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import { Key } from 'react';
import { useIntl } from 'react-intl';

// ===========================|| DATA WIDGET - PROJECT TABLE CARD ||=========================== //

const SpectsFacets = ({ product }: { product: any }) => {
    const intl = useIntl();
    return (
        <>
            {product ? (
                <TableContainer sx={{ maxHeight: 850, bgcolor: 'background.paper' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ ml: 3 }}>
                                <TableCell>{intl.formatMessage({ id: 'product_facets' })}</TableCell>
                                <TableCell>Facets Sku</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ overflow: 'scroll', width: '500px' }}>
                            <TableRow sx={{ ml: 3, verticalAlign: 'top' }}>
                                <TableCell>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Facet</TableCell>
                                                <TableCell>Value</TableCell>
                                                <TableCell>{intl.formatMessage({ id: 'complete' })}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {product?.metric1?.map((metric: any, index: Key | null | undefined) => (
                                                <TableRow key={index}>
                                                    <TableCell>{metric?.specDetailName}</TableCell>
                                                    <TableCell>{metric?.productValue || 'N/A'}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        {metric.productValueScore ? (
                                                            <CheckCircleIcon color="success" />
                                                        ) : (
                                                            <DoNotDisturbOnIcon color="error" />
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableCell>
                                <TableCell>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Facet</TableCell>
                                                <TableCell>{intl.formatMessage({ id: 'complete' })}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {product?.metric2?.map((metric: any, index: Key | null | undefined) => (
                                                <TableRow key={index}>
                                                    <TableCell>{metric?.skuValue}</TableCell>
                                                    <TableCell>
                                                        {metric.skuValueScore ? (
                                                            <CheckCircleIcon color="success" />
                                                        ) : (
                                                            <DoNotDisturbOnIcon color="error" />
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <p>Cargando ..</p>
            )}
        </>
    );
};

export default SpectsFacets;
